import pathToRegexp from 'path-to-regexp';

/**
 * 白名单路径是否匹配当前 pathname（path-to-regexp，end: true）。
 * 用于 App 初始化时判断是否跳过强制拉 Token。
 */
export function searchPath(patterns, pathname) {
  if (!Array.isArray(patterns) || !pathname) return false;
  return patterns.some((pattern) => pathToRegexp(pattern, [], { end: true }).test(pathname));
}
